(function(){

  var imageCache = {}

  function fetchProductImages(handle){
    if(imageCache[handle]) return Promise.resolve(imageCache[handle])
    return fetch('/products/' + handle + '.json')
      .then(function(r){ return r.json() })
      .then(function(data){
        var images = (data.product && data.product.images) || []
        imageCache[handle] = images
        return images
      })
  }

  var caretLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5.5 8L10 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  var caretRight = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3L10.5 8L6 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'

  class WbskSlider extends HTMLElement {

    static get observedAttributes(){
      return ['img-src', 'handle']
    }

    connectedCallback(){
      this._connected = true
      this._tryBuild()
    }

    attributeChangedCallback(){
      if(this._connected) this._tryBuild()
    }

    _tryBuild(){
      if(this._built) return
      var src = this.getAttribute('img-src') || ''
      // wait until AngularJS has interpolated the attributes (no raw { } expressions)
      if(!src || src.indexOf('{') >= 0) return
      this._build()
    }

    _build(){
      if(this._built) return
      this._built = true

      var self = this
      // defer until Swiper is available
      if(typeof Swiper === 'undefined'){
        var check = setInterval(function(){
          if(typeof Swiper !== 'undefined'){
            clearInterval(check)
            self._buildSwiper()
          }
        }, 50)
      } else {
        this._buildSwiper()
      }
    }

    _buildSwiper(){

      var handle = this.getAttribute('handle')
      var src = this.getAttribute('img-src')
      var alt = this.getAttribute('alt') || ''
      var aspect = this.getAttribute('aspect') || 'far-image--square'
      var imgWidth = parseInt(this.getAttribute('img-width')) || 600

      // build DOM
      this.innerHTML =
        '<div class="wbsk-slider wbsk-slider--lazy">' +
          '<div class="swiper-container">' +
            '<ul class="swiper-wrapper">' +
              '<li class="swiper-slide">' +
                '<div class="far-image ' + aspect + ' block-rel">' +
                  '<img alt="' + alt.replace(/"/g, '&quot;') + '" src="' + (src || '') + '">' +
                '</div>' +
              '</li>' +
            '</ul>' +
            '<button type="button" class="wbsk-slider__prev" aria-label="Previous">' + caretLeft + '</button>' +
            '<button type="button" class="wbsk-slider__next" aria-label="Next">' + caretRight + '</button>' +
          '</div>' +
        '</div>'

      // prevent clicks on nav buttons from bubbling to parent <a>
      var prevBtn = this.querySelector('.wbsk-slider__prev')
      var nextBtn = this.querySelector('.wbsk-slider__next')
      ;[prevBtn, nextBtn].forEach(function(btn){
        if(btn) btn.addEventListener('click', function(e){
          e.preventDefault()
          e.stopPropagation()
        })
      })

      // init Swiper
      var swiperEl = this.querySelector('.swiper-container')
      this._swiper = new Swiper(swiperEl, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        }
      })

      // lazy-load: on first next click, fetch all images then slide
      if(handle){
        var slider = this.querySelector('.wbsk-slider')
        var swiper = this._swiper
        var loaded = false

        function onNextClick(e){
          e.preventDefault()
          e.stopPropagation()
          if(loaded) return
          loaded = true
          slider.classList.add('wbsk-slider--loading')

          fetchProductImages(handle).then(function(images){
            if(images.length > 1){
              var newSlides = images.slice(1).map(function(img){
                var s = img.src
                if(s) s = s + (s.indexOf('?') >= 0 ? '&' : '?') + 'width=' + imgWidth
                var a = (img.alt || '').replace(/"/g, '&quot;')
                return '<li class="swiper-slide"><div class="far-image ' + aspect + ' block-rel"><img alt="' + a + '" src="' + (s || '') + '"></div></li>'
              })
              swiper.appendSlide(newSlides)
              swiper.update()
            }
            slider.classList.remove('wbsk-slider--lazy', 'wbsk-slider--loading')
            nextBtn.removeEventListener('click', onNextClick)
            if(swiper.slides.length > 1) swiper.slideNext()
          }).catch(function(err){
            console.warn('wbsk-slider: failed to load images for ' + handle, err)
            slider.classList.remove('wbsk-slider--loading')
            loaded = false
          })
        }

        nextBtn.addEventListener('click', onNextClick)
      } else {
        // no handle = no lazy loading, remove lazy state
        var s = this.querySelector('.wbsk-slider')
        if(s) s.classList.remove('wbsk-slider--lazy')
      }
    }

    disconnectedCallback(){
      if(this._swiper){
        this._swiper.destroy(true, true)
        this._swiper = null
      }
    }
  }

  customElements.define('wbsk-slider', WbskSlider)

})()
